
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("lstlq", function(module, exports) {
$parcel$export(module.exports, "EPCheck", () => $ed6ad6e2c9e568cf$export$662f3e7de71f1a7);
/* eslint-disable jira/filename-case */ 
var $eJOHy = parcelRequire("eJOHy");

var $FhXEJ = parcelRequire("FhXEJ");

var $eWzpp = parcelRequire("eWzpp");

var $5V25X = parcelRequire("5V25X");

var $4cTDP = parcelRequire("4cTDP");

var $14Zcb = parcelRequire("14Zcb");

var $9g0qA = parcelRequire("9g0qA");
const $ed6ad6e2c9e568cf$var$usePostOfficeCheck = (onComplete)=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const epMessageId = (0, $9g0qA.useDeferEpMessageKey)(projectType);
    const { hasMessageStarted: hasMessageStarted, requestMessageStart: requestMessageStart } = (0, $5V25X.usePostOfficeExernalMessageProxy)(epMessageId ?? 'unknown');
    (0, $eJOHy.useEffect)(()=>{
        if (!(0, $4cTDP.fg)('defer-edition-ep-migration-message-proxy-gate')) return; // if post office proxy is disabled, don't start message via Post Office Check
        if (hasMessageStarted || projectType === undefined) return;
        requestMessageStart();
    }, [
        projectType,
        hasMessageStarted,
        requestMessageStart
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if (!hasMessageStarted) return;
        onComplete();
    }, [
        hasMessageStarted,
        onComplete
    ]);
    return hasMessageStarted;
};
const $ed6ad6e2c9e568cf$var$useEPCheck = (onComplete)=>{
    const { data: project } = (0, $eWzpp.useProject)();
    const projectType = (0, $FhXEJ.toProjectType)(project?.type);
    const [hasMessageStarted, setHasMessageStarted] = (0, $eJOHy.useState)(false);
    const [hasCheckedEpMessage, setHasCheckedEpMessage] = (0, $eJOHy.useState)(false);
    const { start: checkEPMessage } = (0, $14Zcb.useCoordinationClient)(projectType);
    (0, $eJOHy.useEffect)(()=>{
        // reset checks when we switch projects
        setHasCheckedEpMessage(false);
        setHasMessageStarted(false);
    }, [
        projectType
    ]);
    (0, $eJOHy.useEffect)(()=>{
        if ((0, $4cTDP.fg)('defer-edition-ep-migration-message-proxy-gate')) return; // if post office proxy is enabled, don't start message via EP Check
        if (hasCheckedEpMessage || projectType === undefined) return;
        (async ()=>{
            setHasCheckedEpMessage(true);
            const hasStarted = await checkEPMessage();
            setHasMessageStarted(hasStarted);
            if (hasStarted) onComplete();
        })();
    }, [
        checkEPMessage,
        hasCheckedEpMessage,
        onComplete,
        projectType
    ]);
    return hasMessageStarted;
};
const $ed6ad6e2c9e568cf$export$662f3e7de71f1a7 = ({ onComplete: onComplete, children: children })=>{
    const engagementPlatformResult = $ed6ad6e2c9e568cf$var$useEPCheck(onComplete);
    const postOfficeResult = $ed6ad6e2c9e568cf$var$usePostOfficeCheck(onComplete);
    const hasMessageStarted = (0, $4cTDP.fg)('defer-edition-ep-migration-message-proxy-gate') ? postOfficeResult : engagementPlatformResult;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, hasMessageStarted && children);
};

});
parcelRegister("14Zcb", function(module, exports) {
$parcel$export(module.exports, "useCoordinationClient", () => $cc91313b90ece059$export$ddc368dc94a41e62);

var $eJOHy = parcelRequire("eJOHy");

var $9zZj0 = parcelRequire("9zZj0");

var $g9Vr6 = parcelRequire("g9Vr6");

var $cHtIB = parcelRequire("cHtIB");

var $9g0qA = parcelRequire("9g0qA");
const $cc91313b90ece059$export$ddc368dc94a41e62 = (projectType)=>{
    const epMessageId = (0, $9g0qA.useDeferEpMessageKey)(projectType);
    const cloudId = (0, $cHtIB.useCloudId)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    const coordinationClient = (0, $eJOHy.useMemo)(()=>new (0, $9zZj0.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement'), [
        cloudId,
        orgId
    ]);
    const start = (0, $eJOHy.useCallback)(async ()=>{
        if (!epMessageId) return false;
        return coordinationClient.start(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    const stop = (0, $eJOHy.useCallback)(()=>{
        if (!epMessageId) return false;
        return coordinationClient.stop(epMessageId);
    }, [
        epMessageId,
        coordinationClient
    ]);
    return {
        start: start,
        stop: stop
    };
};

});
parcelRegister("9g0qA", function(module, exports) {
$parcel$export(module.exports, "useDeferEpMessageKey", () => $db3842fbd856fba9$export$46bdb0804933a5fd);

var $FhXEJ = parcelRequire("FhXEJ");

var $kyq27 = parcelRequire("kyq27");

const $db3842fbd856fba9$export$46bdb0804933a5fd = (projectType)=>{
    const environment = (0, $kyq27.useEnvironment)();
    const isProdEnv = environment === 'prod';
    switch(projectType){
        case 0, $FhXEJ.CORE_PROJECT:
            return isProdEnv ? (0, $94ac5b9dc076858e$export$f36bed87d45a98de) : (0, $94ac5b9dc076858e$export$a0f8b0f73985911a);
        case 0, $FhXEJ.SOFTWARE_PROJECT:
            return isProdEnv ? (0, $94ac5b9dc076858e$export$475f4ac16b63ff71) : (0, $94ac5b9dc076858e$export$3fc71bcf4d7deeea);
        case 0, $FhXEJ.PRODUCT_DISCOVERY_PROJECT:
            return isProdEnv ? (0, $94ac5b9dc076858e$export$58003a8be3bebb14) : (0, $94ac5b9dc076858e$export$4b374f476a475bef);
        case 0, $FhXEJ.SERVICE_DESK_PROJECT:
            return isProdEnv ? (0, $94ac5b9dc076858e$export$b302977ba64b0fa) : (0, $94ac5b9dc076858e$export$bfaa609ebcf522b6);
        default:
            return undefined;
    }
};

});
const $94ac5b9dc076858e$export$b8b9d90f9e5bd72b = 'DeferEditionModal';
const $94ac5b9dc076858e$export$d57b6b390e78d90f = 'transmuters-growth';
const $94ac5b9dc076858e$export$4b374f476a475bef = 'stg-defer-edition-crossflow-jpd';
const $94ac5b9dc076858e$export$3fc71bcf4d7deeea = 'stg-defer-edition-crossflow-jsw';
const $94ac5b9dc076858e$export$a0f8b0f73985911a = 'stg-defer-edition-crossflow-jwm';
const $94ac5b9dc076858e$export$bfaa609ebcf522b6 = 'stg-defer-edition-crossflow-jsm';
const $94ac5b9dc076858e$export$58003a8be3bebb14 = 'defer-edition-crossflow-jpd';
const $94ac5b9dc076858e$export$475f4ac16b63ff71 = 'defer-edition-crossflow-jsw';
const $94ac5b9dc076858e$export$f36bed87d45a98de = 'defer-edition-crossflow-jwm';
const $94ac5b9dc076858e$export$b302977ba64b0fa = 'defer-edition-crossflow-jsm';
const $94ac5b9dc076858e$export$d62ac9eaaf8c4436 = 'COLLECTION';





//# sourceMappingURL=async-jira-defer-edition-ep-check.75c9bb5f.js.map
